import './sass/app.scss'
import './startup'

import Vue from 'vue'
import VueMeta from 'vue-meta'
import DeviceQueries from 'vue-device-queries'

import App from './App.vue'
import router from './router'
import ScrollHub from './plugins/scrollHub'
import ScrollUtils from './plugins/ScrollUtils'
import GlobalVM from './plugins/GlobalVM'
import { GlobalComponents } from './components'
import EventBus from './plugins/eventBus'
import i18n from './locales'

const offset = window.innerHeight * 0.2
const scrollingElement = document.scrollingElement || document.documentElement

Vue.config.productionTip = false

Vue.use(ScrollHub, { scrollingElement, scrollEventTarget: window, reveal: { offset }, trigger: { offset } })
Vue.use(ScrollUtils, { scrollEventTarget: window })
Vue.use(GlobalComponents)
Vue.use(DeviceQueries, { laptop: `min-width: 1088px`, tablet: `min-width: 768px` })
Vue.use(VueMeta)
Vue.use(GlobalVM)
Vue.use(EventBus)

new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')
